var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 0.447716 0.447715 0 1 0H37C37.5523 0 38 0.447715 38 1V37C38 37.5523 37.5523 38 37 38H1C0.447716 38 0 37.5523 0 37V1Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.208 19.1944C27.208 18.5881 27.1536 18.0052 27.0525 17.4456H19V20.7529H23.6015C23.4032 21.8216 22.8009 22.7271 21.8953 23.3334V25.4787H24.6585C26.2753 23.9902 27.208 21.7983 27.208 19.1944Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0002 27.55C21.3087 27.55 23.2441 26.7844 24.6588 25.4786L21.8956 23.3333C21.1299 23.8463 20.1506 24.1494 19.0002 24.1494C16.7733 24.1494 14.8884 22.6454 14.2161 20.6245H11.3596V22.8397C12.7665 25.634 15.6579 27.55 19.0002 27.55Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2161 20.6246C14.0451 20.1116 13.9479 19.5637 13.9479 19.0001C13.9479 18.4366 14.0451 17.8886 14.2161 17.3756V15.1604H11.3596C10.7805 16.3147 10.4502 17.6205 10.4502 19.0001C10.4502 20.3798 10.7805 21.6856 11.3596 22.8399L14.2161 20.6246Z",
    fill: "#FBBC05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0002 13.8508C20.2555 13.8508 21.3826 14.2822 22.2686 15.1294L24.7209 12.6771C23.2402 11.2974 21.3048 10.4502 19.0002 10.4502C15.6579 10.4502 12.7665 12.3662 11.3596 15.1605L14.2161 17.3757C14.8884 15.3548 16.7733 13.8508 19.0002 13.8508Z",
    fill: "#EA4335"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.da1a50a21c82dbf401271403bf8d9ed9.svg";
export { ForwardRef as ReactComponent };